import { LinkComponent } from '@zeiss/beyond-online-react';
import { Link } from 'react-router-dom';

export const ReactRouterLinkComponent: LinkComponent = ({
  href,
  ref,
  ...props
}) => {
  /* istanbul ignore next -- @preserve */
  return <Link to={href || ''} {...props} />;
};
